import { GenericFunction } from './utilityTypes';

export const scrollToTop = (scrollBehavior?: ScrollBehavior): void => {
    if (typeof window === 'undefined') {
        return;
    }
    return window.scrollTo({
        top: 0,
        left: 0,
        behavior: scrollBehavior ?? 'smooth',
    });
};

export const callAndScrollToTop =
    (fn: GenericFunction) =>
    (...args: unknown[]): void => {
        fn(...args);
        scrollToTop();
    };
